import {Component, OnInit, Directive, Output, Input, EventEmitter} from '@angular/core';
import {ForumMessage} from '../../forummessage';
import { ForumService } from '../../forum.service';

@Component({
    selector: 'message-childs',    
    template: require('./message-childs.component.html'),
    providers: [ForumService]
})

export class ForumMessageChildsComponent implements OnInit {    

    userStatus: string;
    @Input('messageClicked') message: ForumMessage;   
    @Output() emiter = new EventEmitter();       

    constructor(private _forumService: ForumService) {
        this.userStatus = "";
    }
    
    ngOnInit() {
        this._forumService.getUserStatus().then(status => {
            this.userStatus = status.role;
        });
    }    

    messageClicked(message: ForumMessage, event: any) {        
        if(message.childs.length > 0) {        
            message.selected = !message.selected;
        }
    }

    answerClicked(message: ForumMessage) {        
        this.emiter.emit({
            value: message
        })
    }

    messageReceived(event: any) {        
        this.answerClicked(event.value);
    }    

    
    getDaysChild(date: any) {
        var dateNow = new Date();
        var dateComment = new Date(date);
        var difference = dateNow.getTime()/1000 - dateComment.getTime()/1000;
        return Math.floor(difference/60/60/24);
    }

    getHoursChild(date: any) {
        var dateNow = new Date();
        var dateComment = new Date(date);
        var difference = dateNow.getTime()/1000 - dateComment.getTime()/1000;
        return Math.floor(difference/60/60);
    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/forum/topic_detail/message_childs/message-childs.component.ts
 **/